
// Business Verified Customer states

const BVC_CREATED = "CREATED";
const BVC_REQUESTED = "REQUESTED";
const BVC_CONFIRMED = "CONFIRMED";

const BVC_STATES = {
  BVC_CREATED,
  BVC_REQUESTED,
  BVC_CONFIRMED,
};

const INIT = "INIT";
const DOCUMENT = "document";
const KBA = "kba";
const RETRY = "retry";
const VERIFIED = "verified";
const UNVERIFIED = "unverified";
const SUSPENDED = "suspended";
const DEACTIVATED = "deactivated";

const DwollaCustomerTypes = {
  USER: "USER",
  BUSINESS: "BUSINESS",
};

const DwollaUserTypes = {
  UNVERIFIED: "UNVERIFIED",
  VERIFIED: "VERIFIED",
}

const DwollaCustomerStates = {
  INIT, DOCUMENT, KBA, RETRY, VERIFIED, SUSPENDED, DEACTIVATED,
};

const DwollaFundingSourceStates = {
  VERIFIED, UNVERIFIED,
};

// Payment from user account to balance.
const FUNDING_0 = "FUNDING_0";
// Payment from balance to TDA_Master
const FUNDING_1 = "FUNDING_1";

// Payment from user account to TDA_Master
const FUNDING_DIRECT = "FUNDING_DIRECT";

// Year, month, day of the expected payment.
const CONTRIBUTION = "CONTRIBUTION_%04d_%02d_%02d";

const PAYMENT = "PAYMENT_%04d_%02d_%02d_%s";

const DwollaPaymentIds = {
  FUNDING_0,
  FUNDING_1,
  FUNDING_DIRECT,
  CONTRIBUTION,
  PAYMENT,
  INVITE_PAYMENT: "INVITE_PAYMENT_%04d_%02d_%02d_%s",
};

const PENDING = "pending";
const PROCESSED = "processed";
const CANCELLED = "cancelled";
const FAILED = "failed";

const DwollaTransferStates = {
  PENDING,
  PROCESSED,
  CANCELLED,
  FAILED,
};

const SCHWAB_ACCOUNT_RE = /^__SCHWAB_ACCOUNT_([-\d]{8})_(\d{4})$/;

const is_master_account = account_name => {

  if (account_name.match(SCHWAB_ACCOUNT_RE)) {
    return true;
  }

  return false;
}

/**
 * Dwolla allows for 3 payment sources.
 */
const MAX_DWOLLA_PAYMENT_SOURCES = 2;

// This signal when the user has granted withdrawal permisssion.
const WITHDRAWAL_GRANTED_EVENT = "WITHDRAWAL_GRANTED_EVENT";

// New payment constants
const UserAcctType = {
  BALANCE: "BALANCE",
  EXTERNAL: "EXTERNAL",
  ACCT_0: "0000",
  ACCT_1: "0001",
  ACCT_2: "0002",
  ACCT_3: "0003",
  ACCT_4: "0004",
  ACCT_5: "0005",
  ACCT_6: "0006",
  ACCT_7: "0007",
  ACCT_8: "0008",
  ACCT_9: "0009",
  ACCT_10: "0010",
}

export { BVC_STATES, DwollaCustomerStates, DwollaCustomerTypes,
  DwollaFundingSourceStates, DwollaPaymentIds, DwollaTransferStates,
  MAX_DWOLLA_PAYMENT_SOURCES, WITHDRAWAL_GRANTED_EVENT,
  DwollaUserTypes, is_master_account, UserAcctType };
